import { showCustomImage, showCustomImageMobile } from 'globalCommon/utils/index';
import { UserLogoMap, UserLogoMapMobile } from '../../common/utils/imageSource';
import commonPageService from 'pcCommon/services/commonPageService';
import { syncRender } from 'globalCommon/services/syncRender';
import './style.css';
import video from 'globalCommon/utils/video';

function init() {
    showCustomImage(UserLogoMap, 'customer-img-lg');
    showCustomImageMobile(UserLogoMapMobile, 'img-list', 'img-item');
    video.init();
    commonPageService({ renderAfter: syncRender, isMobile: 'auto' });
}

init();
